export default "__VITE_ASSET__CW40oNQ6__"